import Slider from '@/components/slider'
import maNavbarStepper from '@/components/navbarStepper'
import { e2eCompensationsSlidesConfig } from './config/e2eCompensations'
import { mapState, mapActions } from 'vuex'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_RESULT_DECLARATION
} from '@/store/types'
import maNavbarCategory from '@/components/navbarCategories'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { FLOW_STATES } from '@/modules/Flow/constants'
import { cloneDeep } from 'lodash'

export default {
  name: 'claimCompensationType',

  mixins: [flowMixin],

  components: {
    Slider,
    maNavbarCategory,
    maNavbarStepper
  },

  data: function () {
    return {
      compensationSlides: e2eCompensationsSlidesConfig(),
      damagesRoom: [],
      damagesWarranty: []
    }
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyWarranties: 'warranties',
      stateWarrantySinisterSummary: 'sinisterSummary'
    }),
    ammountGag() {
      return this.stateFlowViewOptions.smart_values.inmobilier.compensation_base
    }
  },

  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actGetResultDeclaration: WARRANTY_GET_RESULT_DECLARATION
    }),

    handleLinkClick(stateTransition) {
      this.goToNextState(stateTransition)
    },

    async fixDamages() {
      let descriptions = []

      const embellishmentsDamages = cloneDeep(
        this.stateWarrantyWarranties.embellishments
      )
      const immobilierDamages = cloneDeep(
        this.stateWarrantyWarranties.immobilier
      )

      const damagesArr = []

      if (embellishmentsDamages !== undefined) {
        damagesArr.push(embellishmentsDamages.damages)
      }

      if (immobilierDamages !== undefined) {
        damagesArr.push(immobilierDamages.damages)
      }

      damagesArr.forEach((damages) => {
        damages.forEach((damage) => {
          if (damage?.damage.description?.includes(',')) {
            let parts = damage.damage.description.split(',')
            descriptions.push(parts[0])
          }
        })
      })
      this.damagesWarranty = [...descriptions]
    },

    async updateGagSliderAmount() {
      const gagSlide = this.compensationSlides.find(
        (slide) => slide.name === FLOW_STATES.GAG_DETAILS
      )

      if (gagSlide) gagSlide.amount = this.ammountGag
    },

    handleClickPrevRoute() {
      const damagesViewViewName = 'damages-view'
      this.goToView(damagesViewViewName)
    },

    getSliderOptions: function () {
      const sliderOptions = this.compensationSlides.filter((t) =>
        this.getFlowTransitions.includes(t.transition)
      )
      return sliderOptions || []
    },
    async setDamagesDataDescription() {
      const embellishments = this.stateWarrantySinisterSummary
      let embellishmentsRoom = []

      embellishments.forEach((damage) => {
        const singleRoom = damage.selfcare_title.slice(0, -1)
        embellishmentsRoom.push(singleRoom)
      })

      const filteredRoom = new Set(embellishmentsRoom)

      this.damagesRoom = [...filteredRoom]
    },
    replaceDots(value) {
      if (value) {
        if (typeof value === 'number') {
          value = value.toString()
        }
        let valueComma = value.replace(/\./g, ',')

        return valueComma
      }
    }
  },

  async mounted() {
    await this.setDamagesDataDescription()
    const sinisterId = this.getSinisterId
    this.actGetResultDeclaration(sinisterId)
    this.compensationSlides = this.getSliderOptions()
    this.updateGagSliderAmount()
    await this.fixDamages()
  },

  watch: {
    stateWarrantyResultDeclaration() {
      this.updateGagSliderAmount()
    },
    stateWarrantyWarranties() {
      this.fixDamages()
    }
  }
}
